import React from 'react';
import './event.css'; // Updated CSS

function Event() {
  const events = [
    { date: "January 13, 2025", name: "Duruthu Full Moon Poya Day", description: "Commemorating the first visit of the Buddha to Sri Lanka." },
    { date: "February 12, 2025", name: "Navam Full Moon Poya Day", description: "Celebrating the appointment of Buddha’s two chief disciples, Sariputta and Moggallana." },
    { date: "March 13, 2025", name: "Medin Full Moon Poya Day", description: "Marking the Buddha’s first visit to his hometown after enlightenment." },
    { date: "April 12, 2025", name: "Bak Full Moon Poya Day", description: "Celebrating the second visit of the Buddha to Sri Lanka." },
    { date: "May 12, 2025", name: "Vesak Full Moon Poya Day", description: "A sacred day marking the Birth, Enlightenment, and Parinibbana (passing away) of the Buddha." },
    { date: "June 10, 2025", name: "Poson Full Moon Poya Day", description: "Commemorating the introduction of Buddhism to Sri Lanka by Arahant Mahinda." },
    { date: "July 10, 2025", name: "Esala Full Moon Poya Day", description: "Honoring the first sermon of the Buddha, the 'Dhammacakkappavattana Sutta'." },
    { date: "August 08, 2025", name: "Nikini Full Moon Poya Day", description: "Observing the start of the Buddhist retreat season, 'Vassana Samaya'." },
    { date: "September 07, 2025", name: "Binara Full Moon Poya Day", description: "Commemorating the establishment of the Bhikkhuni Sangha (Order of Buddhist Nuns)." },
    { date: "October 06, 2025", name: "Vap Full Moon Poya Day", description: "Marking the end of the three-month Buddhist Lent and Katina Ceremony." },
    { date: "November 05, 2025", name: "Ill Full Moon Poya Day", description: "Signifying the Buddha's proclamation of future Buddhahood for Maitriya." },
    { date: "December 04, 2025", name: "Unduvap Full Moon Poya Day", description: "Celebrating the arrival of Sanghamitta Theri and the sacred Bodhi Tree to Sri Lanka." }
  ];

  return (
    <div className="event-container">
      <div className="event-layout">
        <div className="event-content">
          <h1 className="event-title">Events - 2025</h1>
          <p className="event-description">Join us for these sacred and meaningful Buddhist observances at Ehipassiko Buddhist Centre.</p>

          <div className="event-list">
            {events.map((event, index) => (
              <div key={index} className="event-card">
                <h2 className="event-name">{event.name}</h2>
                <p className="event-date">{event.date}</p>
                <p className="event-details">{event.description}</p>
              </div>
            ))}
          </div>

          <footer className="event-footer">
            <p>🙏 May your path be illuminated with wisdom, peace, and joy. 🙏</p>
          </footer>
        </div>

        <div className="event-gallery">
          <h2 className="gallery-title">Event Moments</h2>
          {/* <div className="gallery-photos">
            <img src="/img1.JPG" alt="Event 1" />
            <img src="/img2.JPG" alt="Event 2" />
            <img src="/img3.jpg" alt="Event 3" />
            <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" />
            <img src="/img1.JPG" alt="Event 1" />
            <img src="/img2.JPG" alt="Event 2" />
            <img src="/img3.jpg" alt="Event 3" />
            <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" />
            <img src="/img1.JPG" alt="Event 1" />
            <img src="/img2.JPG" alt="Event 2" />
            <img src="/img3.jpg" alt="Event 3" />
            <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Event;
